<template>
<div>
  <button class="warn-btn" @click="onAbortBtnClick" >中断检查</button>
  <van-popup
    v-model="editorVisible"
    position="bottom"
    round
    closeable
  >
    <van-form @submit="onSubmit">
      <van-field
        v-model="abortReason"
        name="中断理由"
        label="中断理由"
        placeholder="中断理由"
        :rules="[{required:true,message:'请填写中断理由'}]"
      />
      <div style="padding: 10px;">
        <van-button round block type="primary" class="primary-btn" native-type="submit">确定</van-button>
      </div>
    </van-form>
  </van-popup>
  <van-overlay :show="overlayVisible">
    <van-loading type="spinner" />
  </van-overlay>
</div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'Abort',
  data () {
    return {
      abortReason: '',
      editorVisible: false,
      overlayVisible: false
    }
  },
  computed: {
    ...mapGetters({
      task: 'Task/task'
    })
  },
  methods: {
    onAbortBtnClick () {
      this.abortReason = ''
      this.editorVisible = true
    },
    onSubmit () {
      let params = {
        id: this.task.id,
        reason: this.abortReason
      }
      this.overlayVisible = true
      this.$api.Task.abortHandle(params).then(res => {
        if (res === true) {
          this.overlayVisible = false
          // window.location.href = '/siteselector'
          this.$router.replace({
            name: 'SiteSelector'
          })
        }
      }).catch(console.error).finally(() => {
        this.overlayVisible = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Data/Abort/index.vue